import { SpectrumLicense } from "api/interfaces/reportInterface.interface";
import * as s from "../SystemSpecStyled";
import moment from "moment";
import { useAppSelector } from "redux/hooks";
import { switchStatusColor } from "styles/colors";
import { TableColumnsType } from "antd";
import { ReportTable } from "components/atoms/table/AntdTable";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { getAccountTimeFormatDate } from "utils/timeUtil";
import NoData from "components/templates/nopage/NoData";
import * as mediaQuery from "components/MediaQuery";

interface Props {
  isMap: boolean;
  licenses: SpectrumLicense[];
}
enum replaceTxtObj {
  iomodule = "I/O Module",
  videowall = "Video Wall",
  digital1 = "Professional",
  digital2 = "Time Limit",
  edge = "Edge",
}

interface ActiveLicense {
  type: string;
  channels: string;
  licenseKey: string;
  expires: string;
  status: string;
  isValid: string;
  servername: string;
}

export default function Professional({ licenses, isMap }: Props) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const themeMode = useAppSelector((state) => state.theme.theme);
  const isMobile = mediaQuery.useIsMobile();
  const licenseList: ActiveLicense[] = licenses
    ? licenses.map((el: SpectrumLicense) => {
        let time = moment.utc(el.expiration).tz(selectedAccount.timezone);
        let now = moment.utc().tz(selectedAccount.timezone);
        let typeStr: string =
          el.class !== "digital"
            ? replaceTxtObj[el.class as keyof typeof replaceTxtObj]
            : el.expiration === undefined || el.expiration === ""
            ? replaceTxtObj[(el.class + "1") as keyof typeof replaceTxtObj]
            : replaceTxtObj[(el.class + "2") as keyof typeof replaceTxtObj];
        if (typeof typeStr === "undefined" || typeStr === undefined) {
          typeStr = el.class.charAt(0).toUpperCase() + el.class.slice(1);
        }
        return {
          ...el,
          type: typeStr,
          channels: el.count,
          licenseKey: el.serial,
          expires:
            el.expiration === undefined || el.expiration === ""
              ? "Never"
              : getAccountTimeFormatDate(
                  el.expiration,
                  selectedAccount,
                  true,
                  true
                ),
          status:
            el.expiration === undefined || el.expiration === ""
              ? el.isValid === "true"
                ? "OK"
                : "Error"
              : el.isValid === "true"
              ? time.diff(now) > 0
                ? time.diff(now, `days`) > 30
                  ? "OK"
                  : "Expires soon"
                : "Expired"
              : "Error",
        };
      })
    : [];
  const licenseColumns: TableColumnsType<ActiveLicense> = [
    {
      title: "Type",
      render: (value, row) => row.type,
      width: isMobile ? 70 : 100,
    },
    {
      title: "Channels",
      render: (value, row) => row.channels,
      align: "center",
      width: 60,
    },
    {
      title: "License Key",
      render: (value, row) => row.licenseKey,
      responsive: ["xl"],
    },
    {
      title: "Expires",
      render: (value, row) => row.expires,
    },
    {
      title: "Server",
      render: (value, row) => (
        <span
          style={{
            color: switchStatusColor(
              row.status === "OK" && row.servername !== "" ? "" : row.status,
              themeMode
            ),
          }}
        >
          {row.servername ?? "Server not found"}
        </span>
      ),
      width: 200,
      responsive: ["xxl"],
    },
    {
      title: "Status",
      render: (value, row) => (
        <span style={{ color: switchStatusColor(row.status, themeMode) }}>
          {row.status}
        </span>
      ),
      width: 60,
    },
  ];
  return (
    <>
      <h5 className="title">Active Licenses</h5>
      {isMap ? (
        <s.ActiveLicenseMap>
          {licenseList && licenseList.length > 0 ? (
            licenseList.map((license: ActiveLicense, index: number) => {
              return (
                <li key={`active-license-${index}`}>
                  <div className="license-item">
                    <div className="type">{license.type}</div>
                    <div>
                      <span>{license.channels} Channels</span>
                      <span className="expire">Expires: {license.expires}</span>
                    </div>
                    <div className="licenseKey">
                      <span>{license.licenseKey}</span>
                    </div>
                    <div
                      className="status"
                      style={{
                        color: switchStatusColor(
                          license.status === "OK" && license.servername !== ""
                            ? ""
                            : license.status,
                          themeMode
                        ),
                      }}
                    >
                      <span>{license.servername ?? "Server not found"}</span>
                      <span>{license.status}</span>
                    </div>
                  </div>
                </li>
              );
            })
          ) : (
            <NoData />
          )}
        </s.ActiveLicenseMap>
      ) : (
        <ReportTable dataSource={licenseList} columns={licenseColumns} />
      )}
    </>
  );
}
